/** Maps file extension → canonical MIME type. Single source of truth used by
 *  useFetchDataRoomFiles (MIME resolution) and DocumentViewer (render routing). */
export const EXT_MIME: Record<string, string> = {
    pdf: 'application/pdf',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    xls: 'application/vnd.ms-excel',
    csv: 'text/csv',
    // Images — needed for extension-based fallback when server returns application/octet-stream
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    gif: 'image/gif',
    webp: 'image/webp',
    svg: 'image/svg+xml',
};

/** All MIME types that open in the preview drawer instead of downloading. */
export const PREVIEWABLE_MIME_TYPES = ['application/pdf', 'application/csv', ...Object.values(EXT_MIME)];

/** MIME types routed to SpreadsheetViewer. */
export const SPREADSHEET_TYPES = [EXT_MIME.xlsx, EXT_MIME.xls, EXT_MIME.csv, 'application/csv'];

/** Arrow key identifiers used for keyboard navigation in SpreadsheetViewer. */
export const ARROW_UP = 'ArrowUp';
export const ARROW_DOWN = 'ArrowDown';
export const ARROW_LEFT = 'ArrowLeft';
export const ARROW_RIGHT = 'ArrowRight';
export const ARROW_KEYS = [ARROW_UP, ARROW_DOWN, ARROW_LEFT, ARROW_RIGHT] as const;
